import { Component, OnInit } from '@angular/core';
import {Store} from '@ngrx/store';
import * as fromApp from '../../../store/app.reducers';
import {Observable} from 'rxjs';
import * as fromProfile from '../../store/profile.reducers';

@Component({
    selector: 'app-profile-media-hashtag-rank',
    templateUrl: './profile-media-hashtag-rank.component.html',
    styleUrls: ['./profile-media-hashtag-rank.component.scss'],
    standalone: false
})
export class ProfileMediaHashtagRankComponent implements OnInit {

  profileState: Observable<fromProfile.State>;

  constructor(
    private store: Store<fromApp.AppState>
  ) { }

  ngOnInit() {
    this.profileState = this.store.select('profile');
  }

}
